import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { gcpSortedAccountsSelector } from "./gcpSortedAccountsSelector";
import { nonDeletedAndNotBillingAccountsCombiner } from "../../combiners/nonDeletedAndNotBillingAccountsCombiner";

export const gcpNonDeletedAndNotBillingAccountsSelector =
  createDraftSafeSelector(
    [gcpSortedAccountsSelector],
    nonDeletedAndNotBillingAccountsCombiner,
  );
